export const Role = {
    Admin: 'Admin',
    User: 'User',
    Service: 'Service',
    PC: 'PC',
    Server: 'Server'
}


// WEBPACK FOOTER //
// ./src/auth/role.js